"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var $find = require("../internals/array-iteration").find;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("find", function find(predicate) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
});
